export type InterventionsListFilter = "beforeMonthEnd" | "next30days" | "year" | "all";

/**
 * Préférences société qui pilotent le comportement de l'app mobile EVA-IT.
 * Conçue pour être extensible : ajouter de nouvelles options ici à mesure des besoins.
 */
export class EvaCompanyMobileConfig {
  /** Quand true, la vue "Mon équipe" (planning collaborateurs partagé) est accessible sur mobile. */
  is_team_planning_shared: boolean = false;
  /** Quand true, le bouton "Réaliser les activités" est masqué sur les jours futurs. */
  is_realize_blocked_for_future_days: boolean = false;
  /** Quand true, les employés PROD voient tous les chantiers de la société sur mobile. */
  is_all_projects_visible_by_prod: boolean = false;
  show_project_tags_on_interventions: boolean = false;
  is_unassigned_interventions_visible: boolean = false;
  default_interventions_list_filter: InterventionsListFilter = "next30days";
  /** Visibilité des boutons de saisie d'activité sur mobile. Défaut true côté back
   * (models/eva_company_mobile_config.py) : une société existante non reconfigurée doit voir
   * tous les boutons, donc le défaut TS doit être true aussi (pas seulement avant hydratation —
   * un objet partiel, ex. cache/pré-fetch, doit retomber sur le même comportement que le back). */
  is_intervention_button_visible: boolean = true;
  is_project_button_visible: boolean = true;
  is_absence_button_visible: boolean = true;
  is_meal_break_button_visible: boolean = true;
  /** Visibilité mobile du bouton "Autre activité", indépendante du flag racine
   * `is_other_activity_enabled` (qui active la fonctionnalité elle-même, y compris sur le web). */
  is_other_activity_button_visible: boolean = true;
  /** Masquage fin sur mobile : types d'absence (valeurs AbsenceType) et motifs d'autre activité
   * (other_activity_motif_id) masqués. On stocke les MASQUÉS pour qu'un nouveau type / motif
   * soit visible par défaut. Toujours lire via `Array.isArray(...)` : un cache antérieur n'a pas ces clés. */
  hidden_absence_types: string[] = [];
  hidden_other_activity_motif_ids: string[] = [];
  /** Horodatage ISO (posé côté back) de la dernière modification des boutons de saisie
   * d'activité. Null tant qu'aucun enregistrement n'a jamais eu lieu. */
  buttons_updated_at: string | null = null;

  public static createInstance(jsonData: any): EvaCompanyMobileConfig {
    return Object.assign(new EvaCompanyMobileConfig(), jsonData ?? {});
  }
}
